// extracted by mini-css-extract-plugin
export default {"delimiter":"delimiter--AHxrj","hint":"hint--T1Nnw"};